import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'ps-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  public role: any;
  public forgotPasswordForm: any;
  public isforgotPasswordFormSubmitted!: boolean;

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
    this.role = localStorage.getItem("role");
    this.initialiseforgotPasswordForm();
    localStorage.clear();
  }

  // initialiseforgotpasswordform
  initialiseforgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', Validators.required],
      // role: ['', [Validators.required]]
    })
  }


  // submit form
  onSubmit() {
    this.isforgotPasswordFormSubmitted = true;
    var data = {};
    if (this.forgotPasswordForm.valid) {
      data['email'] = this.forgotPasswordForm.controls['email'].value;
      // data['role'] = this.forgotPasswordForm.controls['role'].value;
      this.authService.ForgetPassword(data).subscribe(res => {
        if (res.status) {
          this.toastr.success("Reset Password Link Has Been Sent Successfully.");
          this.router.navigateByUrl("/auth/login");
        }
        else {
          this.toastr.error("Email Id Entered Is Not Registered With Us.");
        }
      })

    }

  }

  // back
  back() {
    this.router.navigateByUrl("/auth/login");
  }
}